export const exportToCSV = (columns, data, fileName = 'cupons_crawleados.txt') => {
  // Cria o cabeçalho sem aspas, separado por tabs
  const txtHeader = columns.map((col) => col.headerName).join('\t');
  
  // Cria as linhas de dados sem aspas, separado por tabs
  const txtRows = data.map((row) =>
    columns.map((col) => {
      const cellValue = row[col.field];
      return cellValue !== null && cellValue !== undefined ? cellValue.toString() : '';
    }).join('\t')
  );
  
  // Junta tudo com quebras de linha
  const txtContent = [txtHeader, ...txtRows].join('\n');

  // Cria o blob e faz o download
  const blob = new Blob([txtContent], { type: 'text/plain;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};